import { render, staticRenderFns } from "./IndexItem.vue?vue&type=template&id=2a243984&scoped=true&"
import script from "./IndexItem.vue?vue&type=script&lang=js&"
export * from "./IndexItem.vue?vue&type=script&lang=js&"
import style0 from "./IndexItem.vue?vue&type=style&index=0&id=2a243984&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a243984",
  null
  
)

export default component.exports